export const Role = {
    SystemAdmin: 'System Administrator',
    Admin: 'Administrator',
    Sales: 'Sales',
    User: 'User',
    ServiceEngineer: 'Service Engineer'
}